// Utility function to get the appropriate image for each blog based on its slug

// Import all blog images for frontend use
import studyAbroadImage from "../assets/images/study-abroad-application-guide.jpg";
import visaGuideImage from "../assets/images/student-visa-guide.jpg";
import studentLifeImage from "../assets/images/international-student-life.jpg";
import admissionsImage from "../assets/images/graduate-school-admissions.jpg";
import sopImage from "../assets/images/statement-of-purpose.jpg";
import lorImage from "../assets/images/letter-of-recommendation.jpg";
import choosingUniversityImage from "../assets/images/choosing-university.jpg";
import scholarshipImage from "../assets/images/scholarship-tips.jpg";
import defaultBlogImage from "../assets/images/blog.png";

// Backend API base URL for serving images
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5002";

// Map blog slugs to their corresponding images
const blogImageMap = {
  "study-abroad-application-guide": studyAbroadImage,
  "student-visa-guide": visaGuideImage,
  "international-student-life": studentLifeImage,
  "graduate-school-admissions": admissionsImage,
  "statement-of-purpose": sopImage,
  "letter-of-recommendation": lorImage,
  "choosing-university": choosingUniversityImage,
  "scholarship-tips": scholarshipImage,
};

/**
 * Get the appropriate image for a blog based on its slug
 * @param {string} slug - The blog slug
 * @returns {string} - The image path for the blog
 */
export const getBlogImage = (slug) => {
  return blogImageMap[slug] || defaultBlogImage;
};

/**
 * Get blog image by title (fallback method)
 * @param {string} title - The blog title
 * @returns {string} - The image path for the blog
 */
export const getBlogImageByTitle = (title) => {
  if (!title) return defaultBlogImage;

  const titleLower = title.toLowerCase();

  if (
    titleLower.includes("study abroad") ||
    titleLower.includes("application guide")
  ) {
    return studyAbroadImage;
  }
  if (titleLower.includes("visa") || titleLower.includes("student visa")) {
    return visaGuideImage;
  }
  if (
    titleLower.includes("student life") ||
    titleLower.includes("international")
  ) {
    return studentLifeImage;
  }
  if (
    titleLower.includes("admissions") ||
    titleLower.includes("graduate school")
  ) {
    return admissionsImage;
  }
  if (
    titleLower.includes("statement of purpose") ||
    titleLower.includes("sop")
  ) {
    return sopImage;
  }
  if (
    titleLower.includes("letter of recommendation") ||
    titleLower.includes("lor")
  ) {
    return lorImage;
  }
  if (titleLower.includes("choosing") || titleLower.includes("university")) {
    return choosingUniversityImage;
  }
  if (titleLower.includes("scholarship") || titleLower.includes("funding")) {
    return scholarshipImage;
  }

  return defaultBlogImage;
};

/**
 * Get the backend URL for a blog image
 * @param {string} slug - The blog slug
 * @returns {string} - The backend image URL
 */
export const getBlogImageBackendUrl = (slug) => {
  const imageMap = {
    "study-abroad-application-guide": "study-abroad-application-guide.jpg",
    "student-visa-guide": "student-visa-guide.jpg",
    "international-student-life": "international-student-life.jpg",
    "graduate-school-admissions": "graduate-school-admissions.jpg",
    "statement-of-purpose": "statement-of-purpose.jpg",
    "letter-of-recommendation": "letter-of-recommendation.jpg",
    "choosing-university": "choosing-university.jpg",
    "scholarship-tips": "scholarship-tips.jpg",
  };

  const imageName = imageMap[slug];
  return imageName
    ? `${API_BASE_URL}/articles/images/${imageName}`
    : `${API_BASE_URL}/articles/images/blog.png`;
};

export default getBlogImage;
